// Name of the service
export const SERVICE_NAME: string = 'AnsFooterAssets';
export const DELPHI_WIDGET_ID = 'ansChatWidgetWrapperDiv';
export const ABC_WIDGET_ID = 'DelphiChatbotWrapper';

// Direction of the current document
export const enum Direction {
    RIGHT_TO_LEFT = 'rtl',
    LEFT_TO_RIGHT = 'ltr'
}

// Exclude loading of Delphi/ABC on below listed paths.
export const EXCLUDED_PATHS = [
    '/selectiongaps', // High utilization of script by Katal logs.
    '/hz/vendor/members/conseiller/troubleshooter/chatbot', // ABC's landing page
    '/ans/widget/testpage', // Test page of Delphi
    '/hz/vendor/members/contact'
];

// Enable Delphi on listed paths. (SET-2)
export const ONLY_DELPHI_PATHS = [
    '/vendorServices', // VendorHub
    '/help/hub' // HelpHub
];

// Make ABC call for eligibility, DO NOT LOAD DELPHI (SET-3)
export const ONLY_ABC_PATHS = [
    '/hz/vendor/members/v2/vhd' //VHD/SCP
];

export const enum WIDGET_TYPE {
    DELPHI = 'DELPHI',
    AmazonBusinessCoach = 'AmazonBusinessCoach', //ABC
    NONE = 'NONE'
}

/**
 * We have 4 Sets to render different type of widgets:
 * NO_FOOTER: No widget will be surfaced, lazy loading is used to avoid loading assets.
 * ONLY_DELPHI: Only Delphi widget will be surfaced
 * ONLY_ABC: Only ABC widget will be surfaced
 * WEBLAB_SWITCH: Delphi or ABC widget will be surfaced based on weblab treatment.
 */
export const enum PATH_SETS {
    NO_FOOTER = 'NO_FOOTER',
    ONLY_DELPHI = 'ONLY_DELPHI',
    ONLY_ABC = 'ONLY_ABC',
    WEBLAB_SWITCH = 'WEBLAB_SWITCH'
}
